var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmojis02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".c{fill:none;}.d{fill:#fa405c;}.e{fill:#e9dcff;}.f{fill:#5a1372;}.g{clip-path:url(#b);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1144.51,61.5l51.81,357.91c.95,6.56,8.26,9.79,13.43,5.93l324.44-242.45c5.72-4.28,4.15-13.54-2.65-15.63l-376.25-115.46c-5.96-1.83-11.69,3.34-10.77,9.7Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 500,
    cy: 500,
    r: 404
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M500,922.73c-57.06,0-112.42-11.18-164.55-33.23-50.34-21.29-95.55-51.77-134.36-90.59s-69.29-84.02-90.59-134.36c-22.05-52.13-33.23-107.49-33.23-164.55s11.18-112.42,33.23-164.55c21.29-50.34,51.77-95.55,90.59-134.36s84.02-69.29,134.36-90.59c52.13-22.05,107.49-33.23,164.55-33.23s112.42,11.18,164.55,33.23c50.34,21.29,95.55,51.77,134.36,90.59,38.82,38.82,69.29,84.02,90.59,134.36,22.05,52.13,33.23,107.49,33.23,164.55s-11.18,112.42-33.23,164.55c-21.29,50.34-51.77,95.55-90.59,134.36-38.82,38.82-84.02,69.29-134.36,90.59-52.13,22.05-107.49,33.23-164.55,33.23Zm0-808c-52.02,0-102.47,10.18-149.96,30.27-45.88,19.4-87.08,47.19-122.47,82.57-35.39,35.39-63.17,76.59-82.57,122.47-20.08,47.49-30.27,97.94-30.27,149.96s10.18,102.47,30.27,149.96c19.4,45.88,47.19,87.08,82.57,122.47,35.39,35.39,76.59,63.17,122.47,82.57,47.49,20.08,97.94,30.27,149.96,30.27s102.47-10.18,149.96-30.27c45.88-19.4,87.08-47.19,122.47-82.57,35.39-35.39,63.17-76.59,82.57-122.47,20.08-47.49,30.27-97.94,30.27-149.96s-10.18-102.47-30.27-149.96c-19.4-45.88-47.19-87.08-82.57-122.47-35.39-35.39-76.59-63.17-122.47-82.57-47.49-20.08-97.94-30.27-149.96-30.27Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M653,632.08s-69.49,124.92-159.77,124.92-149.02-124.92-149.02-124.92c0,0,69.08,62.72,154.39,62.72s154.39-62.72,154.39-62.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M493.23,775.63c-100.94,0-163.28-130.08-165.88-135.62-3.78-8.04-1.36-17.63,5.78-22.91,7.14-5.28,17.02-4.78,23.6,1.19,.62,.56,65.06,57.88,141.87,57.88s141.25-57.32,141.89-57.9c6.77-6.1,16.96-6.43,24.1-.75,7.13,5.67,9.12,15.66,4.69,23.63-3.05,5.49-75.97,134.49-176.05,134.49Zm-83.94-81.6c20.94,22.19,50.28,44.34,83.94,44.34,19.11,0,48.17-7.38,83.52-39.87-23.21,8.69-49.76,14.93-78.15,14.93-33.05,0-63.61-8.46-89.32-19.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M553.77,480.55c-4.42,0-8.85-1.55-12.42-4.71-7.75-6.86-8.45-18.72-1.59-26.47,1.57-1.77,38.73-43.11,88.87-43.11,.4,0,.79,0,1.19,0,29.89,.39,57.15,15.01,81.04,43.47,6.65,7.92,5.62,19.74-2.3,26.39-7.92,6.65-19.74,5.62-26.39-2.3-16.5-19.66-34.22-29.79-52.64-30.09-.3,0-.6,0-.89,0-33.08,0-60.58,30.21-60.85,30.52-3.7,4.18-8.83,6.31-14,6.31Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 335,
    cy: 447,
    rx: 31.5,
    ry: 53
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M335,515.84c-14.02,0-27.1-8.48-35.89-23.27-7.38-12.42-11.45-28.61-11.45-45.57s4.07-33.15,11.45-45.57c8.79-14.79,21.87-23.27,35.89-23.27s27.1,8.48,35.89,23.27c7.38,12.42,11.45,28.61,11.45,45.57s-4.07,33.15-11.45,45.57c-8.79,14.79-21.87,23.27-35.89,23.27Zm0-106c-5.52,0-15.66,14.11-15.66,37.16s10.14,37.16,15.66,37.16,15.66-14.11,15.66-37.16-10.14-37.16-15.66-37.16Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M326.29,269.63c-1.31-11.77-16.88-19.03-50.22,4.18-43.43,30.24-55.36,87.62-55.36,87.62,0,0,54.38-81.74,76.29-77.16,21.91,4.57,30.6-2.88,29.29-14.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M220.71,367.72c-.81,0-1.63-.16-2.42-.49-2.77-1.16-4.34-4.12-3.72-7.07,.51-2.44,12.96-60.19,57.92-91.5,26.49-18.44,41.55-18,49.53-14.38,5.94,2.7,9.77,8.04,10.51,14.65,1,8.97-2.59,14.31-5.78,17.21-6.38,5.8-16.82,7.24-31.03,4.28-1.02-.21-10.81-1.05-40.17,34.64-15.95,19.39-29.47,39.65-29.6,39.85-1.19,1.79-3.18,2.8-5.23,2.8Zm91.21-102.95c-10.9,0-26.98,10.53-32.25,14.2-15.69,10.93-27.1,25.71-35.2,39.82,.44-.54,.89-1.08,1.33-1.63,31.44-38.24,45.02-40.58,52.49-39.02,13.66,2.85,18.55,.06,20.02-1.28,.56-.51,2.25-2.04,1.75-6.53h0c-.25-2.23-1.3-3.74-3.22-4.61-1.45-.66-3.11-.95-4.92-.95Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M588.24,341.27c-4.72-11.99,6.58-26.89,50.46-21.48,57.17,7.05,97.8,56.22,97.8,56.22,0,0-93.86-51.06-112.63-35.53-18.77,15.53-30.92,12.77-35.64,.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M736.51,381.3c-.86,0-1.73-.21-2.53-.64-.23-.13-23.58-12.79-48.86-23.38-14.69-6.16-27.11-10.41-36.92-12.64-14.89-3.38-19.61-1.18-20.94-.08-11.77,9.74-22.09,13.55-30.68,11.34-6.01-1.55-10.6-5.94-13.26-12.7-2.45-6.23-1.55-12.76,2.46-17.94,5.6-7.22,19.44-14.95,53.58-10.73,58.59,7.22,99.52,56.03,101.24,58.1,1.62,1.96,1.62,4.78,0,6.74-1.04,1.26-2.55,1.93-4.09,1.93Zm-101.54-49.04c12.09,0,29.9,5.05,54.32,15.28,5.73,2.4,11.36,4.91,16.65,7.35-16.78-12.79-40.46-26.47-67.87-29.85-32.79-4.04-41.91,4.12-43.92,6.71-1.74,2.25-2.07,4.79-.97,7.58,1.38,3.52,3.42,5.65,6.05,6.32,2.88,.74,9.48,.53,21.29-9.24,3.33-2.76,8.11-4.15,14.46-4.15Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 727.03,
    y: 18.39,
    width: 666.13,
    height: 72.8,
    transform: "translate(185.22 655.94) rotate(-37.45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 771.3,
    y: 76.18,
    width: 666.13,
    height: 72.8,
    transform: "translate(159.2 694.78) rotate(-37.45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 815.57,
    y: 133.98,
    width: 666.13,
    height: 72.8,
    transform: "translate(133.18 733.62) rotate(-37.45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 859.84,
    y: 191.77,
    width: 666.13,
    height: 72.8,
    transform: "translate(107.16 772.45) rotate(-37.45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 904.11,
    y: 249.56,
    width: 666.13,
    height: 72.8,
    transform: "translate(81.14 811.29) rotate(-37.45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 948.38,
    y: 307.35,
    width: 666.13,
    height: 72.8,
    transform: "translate(55.12 850.12) rotate(-37.45)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojis02);
export default __webpack_public_path__ + "static/media/Emojis-02.dd80ed84db6f8992375cdf47627e78d2.svg";
export { ForwardRef as ReactComponent };